import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AssetCustomer.css";
import "./menu3.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Headers from "../Home/Header";
import Footer from "../Home/Footer";
import TicketSidebar from "../components/TicketSidebar";

axios.defaults.withCredentials = true;

const AssetDetailCustomer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [asset, setAsset] = useState(location.state?.asset || null);

  useEffect(() => {
    const fetchAssetDetail = async () => {
      try {
        const res = await axios.get(
          `/project-customers/my-assets/${id}`,
          { withCredentials: true },
        );
        setAsset(res.data || null);
      } catch (err) {
        console.error("fetchAssetDetail error:", err);
      }
    };

    if (id) {
      fetchAssetDetail();
    }
  }, [id]);

  const isExpired = asset?.ma_status === "Non-active";

  const handleCreateTicket = () => {
    if (isExpired) {
      alert(
        "ไม่สามารถสร้าง Ticket ได้ เนื่องจาก Status of service เป็น Expired",
      );
      return;
    }

    navigate(`/customer/assets/${id}/new-ticket`, {
      state: { selectedAsset: asset },
    });
  };

  return (
    <>
      <Headers />
      <div className="asset-page">
        <TicketSidebar active="/customer/assets" />

        <div className="asset-main">
          <div className="asset-detail-card">
            <div className="asset-detail-header">
              <button className="back-btn" onClick={() => navigate(-1)}>
                Back
              </button>

              <h2>Asset configuration</h2>

              <button
                className={`new-ticket-btn ${isExpired ? "disabled-ticket-btn" : ""}`}
                onClick={handleCreateTicket}
                disabled={isExpired}
                title={
                  isExpired
                    ? "ไม่สามารถสร้าง Ticket ได้ เพราะบริการหมดอายุแล้ว"
                    : "Create New Ticket"
                }
              >
                {isExpired ? "Service Expired" : "New Ticket"}
              </button>
            </div>

            <div className="asset-detail-grid">
              <div className="detail-field">
                <label>Company Name :</label>
                <input type="text" value={asset?.company_name|| ""} readOnly />
              </div>

              <div className="detail-field">
                <label>Serial number :</label>
                <input type="text" value={asset?.prd_serial || ""} readOnly />
              </div>

              <div className="detail-field">
                <label>Product :</label>
                <input type="text" value={asset?.prd_ref || ""} readOnly />
              </div>

              <div className="detail-field">
                <label>Current End Date :</label>
                <input
                  type="text"
                  value={asset?.contract_year || ""}
                  readOnly
                />
              </div>
            </div>

            <div className="coverage-title">🛠 Asset coverage</div>

            <div className="coverage-box">
              <div className="coverage-box-title">
                {asset?.coverage_name || "Customer Asset Coverage"}
              </div>

              <div className="coverage-grid">
                <div className="coverage-item warranty-remaining-item">
                  <div className="coverage-label">Warranty Remaining:</div>
                  <div className="coverage-value">
                    <span
                      className={
                        asset?.ma_status === "Active"
                          ? "warranty-remaining-badge"
                          : "warranty-remaining-badge expired"
                      }
                    >
                      {asset?.coverage_duration || "-"}
                    </span>
                  </div>
                </div>

                <div className="coverage-item">
                  <div className="coverage-label">Status of service:</div>
                  <div className="coverage-value">
                    <span
                      className={
                        asset?.ma_status === "Active"
                          ? "status-badge active"
                          : "status-badge expired"
                      }
                    >
                      {asset?.ma_status || "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AssetDetailCustomer;
